import React, { MouseEventHandler } from 'react';
import { ButtonRow } from '../../Buttons/ButtonRow';

type TTakePhotoProps = {
    label?: string;
    iconName?: string;
    handleClick: MouseEventHandler;
};
const TakePhoto = ({ label, iconName, handleClick }: TTakePhotoProps) => {
    return <ButtonRow as="button" isWidget={false} isHide={false} disabled={false} label={label} iconName={iconName} handleClick={handleClick} />;
};
export { TakePhoto };
